export default {
    arrayToString: function (array) {
        return String.fromCharCode.apply(null, new Uint16Array(array.buffer));
    },
    base64ToUint8Array: function (base64String) {
        var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        var base64 = (base64String + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/');
        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);
        for (var i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    },
    arrayBufferToBase64: function (buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    },
    stringToArray: function (string) {
        var length = string.length;
        // 2 bytes for each char
        var buffer = new ArrayBuffer(length * 2);
        var array = new Uint16Array(buffer);
        for (var i = 0; i < length; i++) {
            array[i] = string.charCodeAt(i);
        }
        return array;
    },
};
